import React from 'react';
import { TabsProps } from '@mui/material';
import { CustomTabs } from './tabs.styles';

const Tabs: React.FC<TabsProps> = ({ orientation = 'horizontal', ...props }) => (
  <CustomTabs {...props} orientation={orientation} />
);

export default React.memo(Tabs);
